// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_c8-3";
export var flatBottomCorners = "_c8-5";
export var productImage = "_c8-0";
export var quantityContainer = "_c8-2";
export var quantityHeader = "_c8-6";
export var tooltip = "_c8-1";
export var wrapAndEllipsesOverflow = "_c8-4";